import { render } from "./MyLogo.vue?vue&type=template&id=70fed6a0"
const script = {}

import "./MyLogo.vue?vue&type=style&index=0&id=70fed6a0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__